import GeoPositionFormatter from 'src/components/Layouts/GeoPositionFormatter';
import i18n from 'src/i18n';
import Tables from 'src/class/Tables';

const configTable = () => {
  const Table = { ...Tables.Table };
  Table.tableColumns = [
    {
      prop: 'name',
      label: i18n.t('common_words.name'),
      minWidth: 100,
      sortable: true,
    },
    {
      prop: 'code_station',
      label: i18n.t('common_words.code_serial'),
      sortable: true,
      align: 'center',
    },
    {
      prop: 'station_type',
      label: i18n.t('common_words.type'),
      sortable: true,
      align: 'center',
    },
    {
      prop: 'station_mark',
      label: i18n.t('devices.brand'),
      sortable: true,
      align: 'center',
    },
    {
      prop: 'label_is_request',
      label: i18n.t('common_words.api_request'),
      sortable: true,
      align: 'center',
    },
    {
      prop: 'latitude',
      label: i18n.t('common_words.geo_position'),
      sortable: true,
      minWidth: 150,
      formatter: GeoPositionFormatter,
    },
    /* {
      prop: 'longitude',
      label: i18n.t('common_words.longitude'),
      sortable: true,
      align: 'center',
    },
    {
      prop: 'altitude',
      label: i18n.t('common_words.altitude'),
      sortable: true,
      align: 'center',
    }, */
  ];

  return { Table };
};

export default configTable;
